<template>
  <v-row>
    <!-- Título e status -->
    <v-col cols="12" md="7">
      <v-card-title class="text-h6 text-uppercase font-weight-bold">
        Lançamento de notas do {{ trimestre }}
      </v-card-title>

      <span class="error--text ml-4" v-if="isPautaBloqueada">
        <v-icon color="error" size="18" left>mdi-lock</v-icon>
        Pauta Bloqueada
      </span>

      <v-snackbar v-model="snackbar" centered right color="info">
        {{ text || '' }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="$emit('fecharSnackbar')">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </v-col>

    <!-- Botão publicar -->
    <v-col cols="12" md="5" class="d-flex justify-end mt-4">
      <v-btn
        :disabled="pautaLancada"
        class="mr-md-4 mx-sm-auto"
        @click="$emit('publicarPauta')"
        color="primary"
      >
        Finalizar e Bloquear Lançamento
      </v-btn>
    </v-col>

    <!-- Mensagem de pauta -->
    <v-col cols="12" md="5">
      <div v-if="hasMessage" :style="estiloPauta" :class="classMessage">
        {{ textMessage }}
      </div>
    </v-col>
  </v-row>
</template>

  
  <script>
  export default {
    name: 'PainelLancamentoNotas',
    props: {
      trimestre: {
        type: String,
        required: true,
      },
      tipoNota: {
        type: Number,
        required: true,
      },
      isPautaBloqueada: Boolean,
      pautaLancada: Boolean,
      isRuleRolePed: Boolean,
      snackbar: Boolean,
      text: String,
      estiloPauta: Object,
      hasMessage: Boolean,
      classMessage: String,
      textMessage: String,
    },
  };
  </script>
  